import React from 'react';

import {
    NIKE1,
    NIKE1_DETAIL,
    NIKE1_MATCH,
    NIKE1_MENU_ITEM_TOURNAMENT,
    NIKE1_TOURNAMENT,
    TURBO_LIVE_FAVORITES,
    TURBO_LIVE_SPORT,
    VIRTUAL_GAMES
} from '@/routing/routes';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';
import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { useSticky } from '@/_hooks/useSticky';

export const NikeOneHeader = ({ active }) => {
    const scrollElementRef = useHeaderTabsScroll();
    const [scrolled] = useSticky(40);
    return (
        <>
            <UserBoardHeader pageHeaderClassName={!scrolled ? 'non-shadow' : null} />
            <HeaderTabsContainer className={'shadow'}>
                <TabButton
                    route={NIKE1}
                    i18nCode="nikeOne.all"
                    data-atid="main-menu-prematch"
                    activeRoute={active}
                    activeCheck={[NIKE1_DETAIL, NIKE1_TOURNAMENT, NIKE1_MENU_ITEM_TOURNAMENT, NIKE1_MATCH]}
                    params={{ sportSlugPart: 'dnes' }}
                    scrollElementRef={scrollElementRef}
                />
                <TabButton
                    route={TURBO_LIVE_SPORT}
                    i18nCode="nikeOne.live"
                    data-atid="main-menu-live"
                    activeRoute={active}
                    activeCheck={[TURBO_LIVE_FAVORITES]}
                    scrollElementRef={scrollElementRef}
                />
                <TabButton
                    route={VIRTUAL_GAMES}
                    data-atid="main-menu-virtuals"
                    i18nCode="nikeOne.virtual"
                    activeRoute={active}
                    scrollElementRef={scrollElementRef}
                />
            </HeaderTabsContainer>
        </>
    );
};
